module.exports = __webpack_public_path__ + "static/img/qnset5.42d9ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset5.png
// module id = 359
// module chunks = 0